export const DEFAULT_INTERVAL = '1D';
export const DEFAULT_TIMEZONE = 'exchange';
